/**
 * Violation Descriptions Map - Client Side
 * 
 * This file contains all violation descriptions used throughout the application.
 * Using a centralized map makes it easy to update descriptions in the future.
 * 
 * Keys should match the ViolationScreenName from the violationmaster table.
 */

const violationDescriptions = {
  // Driving Violations
  'Over Speed (Crossing Speed Limit)': 'Driving the vehicle above the permissible speed limit.',
  'Hitting and Damaging Organizational Property': 'Collisions with any object present in the environment which is organizational property.',
  'Hitting or Injuring a Person': 'Hitting and injuring a person present in the environment.',
  'Unsafe Driving with Visual Obstruction by Load': 'Unsafe Driving with visual obstruction from load.',
  'Fork in Unsafe Position while Driving': 'Driving the Forklift with the forks in an unsafe or incorrect position.',
  
  // Loading/Unloading Violations
  'Placing Load Incorrectly': 'Placing the loads in an incorrect position.',
  'Lifting Load Incorrectly': 'Lifting the load in an unsafe manner.',
  
  // Parking Violations
  'Parking Vehicle Improperly': 'Instances where the vehicle has not been parked within the designated area or alignment.',
  
  // Operation Violations
  'Performing Simultaneous Two Activities at Once': 'Executing two vehicle operations simultaneously in a way that violates safety or task rules.',
  'Indicator Shown Incorrectly': 'Using wrong or misleading turn signals while driving.',
  'Not Following Traffic Signals': 'Ignoring or disobeying traffic signals.',
  'Hitting and Damaging a Diffrent Vehicle': 'Hitting and damaging other vehicles present in the environment.',
  'Not Blowing Horn Properly at Places': 'Failure to blow horn at required places as per the rules or signs.',
  'Unsafe Driving on Inclined Planes': 'Driving on an inclined plane in a way that violates safety or task rules.'
};

export default violationDescriptions; 